import { cn } from '@/utils/styles';
import type { DailyServingData } from '@viome/viome-base/src/usecase/Nutrition/Nutrition.model';

export interface NutritionPageServingsCountProps
  extends React.ComponentProps<'div'> {
  servingData: DailyServingData;
}

const MACROS_COLORS = {
  Vegetables: '#C3E5CC',
  Proteins: '#D4C3E5',
  'Grains or Starches': '#C3CFE5',
  Fruits: '#FCDD9C',
  Fats: '#FF6054',
  DEFAULT: '#D4C3E5',
} as Record<string, string>;

const renderServingCountBullets = (servingData?: DailyServingData) => {
  const { macros, servings } = servingData ?? {};

  if (!servings) return null;

  const color = (macros && MACROS_COLORS[macros]) ?? MACROS_COLORS.DEFAULT;

  const renderedServingCountBullets = Array.from({ length: servings }).map(
    (_, index) => (
      <li
        key={`nutrition-skeleton-${index}`}
        className="size-2 rounded-full"
        style={{ backgroundColor: color }}
      />
    ),
  );

  return renderedServingCountBullets;
};

export const NutritionPageServingsCount = ({
  className,
  servingData,
}: NutritionPageServingsCountProps) => {
  return (
    <ul
      dir="rtl"
      className={cn(
        'grid grid-cols-10 items-center justify-end gap-1',
        className,
      )}
    >
      {renderServingCountBullets(servingData)}
    </ul>
  );
};
